/* eslint-disable no-irregular-whitespace */
import {commonPromise} from '../../http'
import {
    WEB_VIDEO
} from '../global'

export const getWebVideo = (data) => commonPromise(data, WEB_VIDEO);// 获取课程视频URL



// WEBPACK FOOTER //
// ./src/api/apiModules/baseApi.js